export const isTestingEnvironment = () => {
  if (!!window?.Cypress && process.env.NEXT_PUBLIC_ENV !== 'production') {
    return true;
  }

  return false;
};
